import { computed, ComputedRef } from 'vue';
import { useStore } from 'vuex';

export function useRTL(): ComputedRef<boolean> {
  const store = useStore();

  return computed(() => store.state.locale == 'he' || store.state.locale == 'ar');
}
